shvenergy.cookiewarning = (function ($) {
	"use strict";

	function init() {

		var DEFAULT_COOKIE_EXPIREDAYS = 5;

		var cookieWarning = $(".cookie-banner");

		if (cookieWarning.length < 1) {
			return;
		}

		var cookieWarningButton = $(".cookie-banner button");
		var cookieExpireDays = cookieWarning.data("cookiedays");

		try {
			cookieExpireDays = parseInt(cookieExpireDays);
		} catch (e) {
			cookieExpireDays = DEFAULT_COOKIE_EXPIREDAYS;
		}

		var currentCookieWarningCookie = shvenergy.cookies.getCookie("_shvenergy_cookie_warning");

		//For Calor's shop we always include the cookiebanner in the HTML, so we also have to check if the cookie is set or not.
		//If it is set we need to remove it
		if (currentCookieWarningCookie) {
			cookieWarning.remove();
		} else {

			cookieWarningButton.on("click", function () {

				shvenergy.cookies.setCookie("_shvenergy_cookie_warning", "true", cookieExpireDays);

				cookieWarning.removeClass("is-Shown");
				setTimeout(function () {
					cookieWarning.remove();
				}, 600);

			});

			cookieWarning.addClass("is-Shown");

		}



	}

	init();

})(jQuery);